import { Option } from '../../../ui-components/core-dropdown/core-dropdown.component';
import {
  Contact,
  Gender,
} from '../../definition/patient/interface/patient.interface';
import {
  ICasePayment,
  ICaseStatusLogs,
  IServiceInformation,
} from '../components/case-card/interfaces/case-card-interfaces';

export enum CaseStatusesEnum {
  started = 'started',
  canceled = 'canceled',
  finished = 'finished',
}

export enum CaseApproveStatus {
  APPROVED = 'approved',
  NOT_APPROVED = 'notApproved',
}


export enum CaseRecordTypeEnum {
  case = 'case',
  appointment = 'appointment',
}

export interface CaseState {
  case: {
    caseType: any;
    id: number | null;
    uid: string | null;
    caseNo: number | null;
    caseDate: Date | null;
    caseStatus: CaseStatusesEnum | null;
    appointmentStatus: CaseStatusesEnum | null;
    recordType: CaseRecordTypeEnum | null;
    appointmentStartDate: Date | null;
    appointmentEndDate: Date | null;
    appointmentDuration: string | null;
    createdAt: Date | null;
    patientInformations: ICasePatientInformations | null;
    caseInformations: ICaseInformations | null;
    addressInformations: ICaseAddressInformations | null;
    serviceInformations: IServiceInformation | null;
    paymentInformations: ICasePayment[];
    documentInformations: any;
    vehicleStatusInformations: any;
    inspectionInformation: any;
    callCardInformations: any;
    cancelReason: number | null;
    cancelDescription: string | null;
    isCaseApproved: boolean | null;
    isSendCerebral: boolean | null;
    isSendLabmed: boolean | null;
    patient: ICasePatient;
    mainVehicleLog:ICaseStatusLogs | null;
    plannedVehicle:{id:number,licensePlate:string,vehicleNo:string}|null;
    plannedStaff:any;
    patientFile?:any;
    childAppointments: [],
    parentAppointment: null,
    parentAppointmentId: null,
    isExcelData: boolean;
  };
  loading: boolean;
  blackList: string[];
  error: string | null;
  isReadonly: boolean;
  userInFile: string | null;
}

export interface ICaseInformations {
  assuranceType: Option | null;
  freeType: Option | null;
  priceType: Option | null;
  causeReason: Option | null;
  serviceReason: Option | null;
  institution: Option | null;
  memberFullname: string | null;
  memberContractNo: number | null;
  memberNo: number;
  protocolNo: string | null;
  labmedNo: string | null;
  triage: Option | null;
  userNote: string | null;
  complaint: string | null;
  diagnoses: any[];
  vitalSigns: any[];
  staff?:any;
  patientFullName?:string;
  supportStaff?:string;
  time?:string;
  department?:string;
  supplier?:string;
}

export interface ICasePatientInformations {
  patientNo: number | null;
  firstName: string | null;
  lastName: string | null;
  idNumber: string | null;
  unidentified: boolean | null;
  birthDate: Date | null;
  age: number | null;
  bloodGroup: Option | null;
  country: Option | null;
  gender: Gender | null;
  isForeignNational: boolean | null;
  passportNo: string | null;
  medicalRecords: any[];
  contacts: Contact[];
  description: string | null;
  idNumberVerified: boolean | null;
  specialCategoryTags?: any[] | null;
}

export interface ICaseAddressInformations {
  pickupInstitution: Option | null;
  dropoffInstitution: Option | null;
  pickupAddress: any;
  dropoffAddress: any;
  dropoffInstitutionApproval: boolean;
  dropoffInstitutionDescription: string | null;
}

export interface CaseGetList {
  caseType?: number | null;
  phone?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  idNumber?: string | null;
  passport?: string | null;
  caseNo?: string | null;
  caseStatus?: string | null;
  institution?: number | null;
  priceType?: number | null;
  protocolNo?: string | null;
  startDate?: Date | null;
  endDate?: Date | null;
  first?: number | null;
  rows?: number | null;
  caseApprove?:string | null;
  dropoffInstitution?:number | null;
  pickupInstitution?:number | null;
}

export interface ISaveAppointment {
  appointmentStartDate: Date | null;
  appointmentEndDate: Date | null;
  appointmentDuration: string | null;
  plannedVehicle:number | null;
  plannedStaff?:any | null;
}

export interface ICaseDocument {
  id?: number;
  fileName: string;
  savedType: CaseDocumentSavedTypeEnum;
  mimeType?: string;
  description: string;
  fileUrl: string;
  createdAt: string;
  createdBy: string;
}

export enum CaseDocumentSavedTypeEnum {
  AMBULANCE = 'ambulance',
  USER = 'user',
  PATIENT = 'patient',
}

export interface ICasePatientAddress {
  city: string;
  country: string;
  district: string;
  formattedAddress: string;
  isPriority: boolean;
  latitude: number;
  longitude: number;
  postalCode: string;
  street: string;
  title: { valueObject: { id: { value: number }; name: { value: string } } };
}

export interface ICasePatient {
  id: number | null;
  firstName: string;
  lastName: string;
  category: any[];
  gender: Gender | null;
  age: number | null;
  contacts: Contact[];
  addresses: ICasePatientAddress[];
  medicalRecords?:any[];
  specialCategoryTags?: any[] | null;
}
